export default __webpack_public_path__ + "static/use-2-es-b23a93f6246a13f9910af4e62a4dfda8.png";